import { postDataPromise } from 'brock-fetch-utils';
import { getApiUri } from '../../viewDashboards/utils/getUri';

export const isFavoriteDisabled = window.isKioskMode;

export function getIsFavorite(itemKey, parameterId) {
    return postDataPromise(getApiUri('SmartSuiteMenuApi'), {
        method: 'getIsFavorite',
        payload: {
            itemKey,
            parameterId,
            url: window.location.href,
        },
    });
}

export function saveFavorite(
    itemKey,
    favoriteName,
    source,
    parameterId,
    viewKey,
    parameterDescription
) {
    return postDataPromise(getApiUri('SmartSuiteMenuApi'), {
        method: 'saveFavorite',
        payload: {
            itemKey,
            viewKey,
            parameterId,
            parameterDescription,
            favoriteName,
            source,
            url: window.location.href,
        },
    });
}

export function deleteFavorite(itemKey, favoriteName, source, parameterId) {
    return postDataPromise(getApiUri('SmartSuiteMenuApi'), {
        method: 'deleteFavorite',
        payload: {
            itemKey,
            parameterId,
            favoriteName,
            source,
            url: window.location.href,
        },
    });
}

export function getLandingPageWidgetUserFavorites() {
    return postDataPromise(getApiUri('SmartSuiteMenuApi'), {
        method: 'getLandingPageWidgetUserFavorites',
    });
}

export default {
    isFavoriteDisabled,
    getIsFavorite,
    saveFavorite,
    deleteFavorite,
    getLandingPageWidgetUserFavorites,
};
